<section id="addNewUser">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="manage-action-blk">
        <button
          mat-stroked-button
          color="primary"
          class="item-each"
          [routerLink]="['../add-user']"
          routerLinkActive="router-link-active"
        >
        <span translate class="translate">pages.newRetailer.addNewUser</span> <i class="mi mi-add-box"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="user-details-form-container">
        <mat-card class="shadow p-0">
          <form [formGroup]="newUserForm" (ngSubmit)="addUserSubmit($event)">
            <div class="form-inner content-details-blk">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div
                      class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                    >
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.firstName
                        <span class="required">*</span>
                      </h4>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                    >
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <input
                            matInput
                            required
                            [textMask]="{ mask: charMask, guide: false }"
                            formControlName="firstName"
                            placeholder="{{ 'pages.placeholders.Enterfirstname' | translate }}"
                          />
                        </mat-form-field>
                        <div *ngIf="f.firstName.touched && f.firstName.invalid">
                          <div *ngIf="f.firstName.errors.required">
                            <mat-hint class="text-danger ms-2">
                              {{ 'pages.placeholders.Firstnameisrequired' | translate }}</mat-hint
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div
                      class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                    >
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.lastName
                        <span class="required">*</span>
                      </h4>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                    >
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <input
                            matInput
                            required
                            [textMask]="{ mask: charMask, guide: false }"
                            formControlName="lastName"
                            placeholder="{{ 'pages.placeholders.Enterlastname' | translate }}"
                          />
                        </mat-form-field>
                        <div *ngIf="f.lastName.touched && f.lastName.invalid">
                          <div *ngIf="f.lastName.errors.required">
                            <mat-hint class="text-danger ms-2">
                              {{ 'pages.placeholders.Lastnameisrequired' | translate }}</mat-hint
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div
                      class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                    >
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.userName
                        <span class="required">*</span>
                      </h4>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                    >
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <input
                            matInput
                            required
                            [textMask]="{ mask: charMask, guide: false }"
                            formControlName="userName"
                            placeholder="{{ 'pages.placeholders.EnterUsername' | translate }}"
                          />
                        </mat-form-field>
                        <div *ngIf="f.userName.touched && f.userName.invalid">
                          <div *ngIf="f.userName.errors.required">
                            <mat-hint class="text-danger ms-2">
                              {{ 'pages.login.usernameRequired' | translate }}</mat-hint
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div
                      class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                    >
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.emailInput
                        <span class="required">*</span>
                      </h4>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                    >
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <input
                            matInput
                            required
                            placeholder="{{'pages.AddProviders.EnteremailAddress' | translate }}"
                            formControlName="email"
                          />
                        </mat-form-field>
                        <div *ngIf="f.email.touched && f.email.invalid">
                          <div *ngIf="f.email.errors.required">
                            <mat-hint class="text-danger ms-2">
                              {{ 'pages.placeholders.EmailIdisrequired' | translate }}</mat-hint
                            >
                          </div>
                          <div *ngIf="f.email.errors.pattern">
                            <mat-hint class="text-danger ms-2">
                              {{ 'pages.placeholders.Invalidformat' | translate }}</mat-hint
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div
                      class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                    >
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.mobileNumber
                        <span class="required">*</span>
                      </h4>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                    >
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <input
                            matInput
                            [textMask]="{ mask: phone }"
                            required
                            formControlName="mobileNumber"
                            placeholder="{{'pages.Creditlinebalance.Entermobilenumber' | translate }}"
                          />
                        </mat-form-field>
                        <div
                          *ngIf="
                            f.mobileNumber.touched && f.mobileNumber.invalid
                          "
                        >
                          <div *ngIf="f.mobileNumber.errors.required">
                            <mat-hint class="text-danger ms-2">
                              {{ 'pages.placeholders.MobileNumberisrequired' | translate }}</mat-hint
                            >
                          </div>
                          <div *ngIf="f.mobileNumber.errors.pattern">
                            <mat-hint class="text-danger ms-2"
                              >{{ 'pages.placeholders.PleaseEnter10digitMobileNumber' | translate }}</mat-hint
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div
                      class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                    >
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.role
                        <span class="required">*</span>
                      </h4>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                    >
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-select
                            formControlName="role"
                            placeholder="{{'pages.placeholders.SelectRole' | translate }}"
                            (selectionChange)="onRoleSelected($event)"
                          >
                            <mat-option
                              *ngFor="let role of roles"
                              [value]="role"
                            >
                              {{ role }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <div *ngIf="f.role.touched && f.role.invalid">
                          <div *ngIf="f.role.errors.required">
                            <mat-hint class="text-danger ms-2">
                              {{'pages.placeholders.RoleisRequired' | translate }}</mat-hint
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-lg-6 col-md-6 col-xs-12" *ngIf="showRetailerList">
                  <div class="row g-0">
                    <div
                      class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                    >
                      <h4 class="form-item-label" translate>
                        {{'pages.Creditlinereport.Retailer' | translate }}
                        <span class="required">*</span>
                      </h4>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center" 
                    >
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-select
                            formControlName="retailerId"
                            placeholder="Select retailer"
                          >
                            <mat-option
                              *ngFor="let businessname of businessnames"
                              [value]="businessname.retailerId"
                            >
                              {{ businessname.businessName }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <div *ngIf="f.retailerId.touched && f.retailerId.invalid">
                          <div *ngIf="f.retailerId.errors.required">
                            <mat-hint class="text-danger ms-2">
                              Retailer is required.</mat-hint
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12" *ngIf="showRetailerList" >
                    <div class="row g-0">
                      <div
                        class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                      >
                        <h4 class="form-item-label" translate>
                          pages.newRetailer.iVRAccess
                          <span class="required">*</span>
                        </h4>
                      </div>

                      <div
                        class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center" 
                      >
                        <div class="form-item-input">
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-select (selectionChange)="onIvrStatusChange($event.value)"
                              formControlName="ivrAccess"
                              placeholder="Select IVRAccess"
                              selected="No"
                            >
                              <mat-option value='Yes'>Yes</mat-option>
                              <mat-option value='No'>No</mat-option>
                            </mat-select>
                          </mat-form-field>
                          <div *ngIf="f.ivrAccess.touched && f.ivrAccess.invalid">
                            <div *ngIf="f.ivrAccess.errors.required">
                              <mat-hint class="text-danger ms-2">
                                IVR Access is required.</mat-hint
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngIf="showIvrCode">
                      <div class="row g-0">
                        <div
                          class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                        >
                          <h4 class="form-item-label" translate>
                            pages.newRetailer.iVRCode <span class="required">*</span>
                          </h4>
                        </div>
                        <div
                          class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                        >
                          <div class="form-item-input">
                            <mat-form-field appearance="outline" class="w-100">
                              <input
                                matInput
                                required
                                formControlName="ivrCode"
                                placeholder="4 Digit Code"
                              />
                            </mat-form-field>
                            <div *ngIf="f.ivrCode.touched && f.ivrCode.invalid">
                              <div *ngIf="f.ivrCode.errors.required">
                                <mat-hint class="text-danger ms-2">
                                  4 Digit Code is required.</mat-hint
                                >
                              </div>
                            </div>
                          </div>
                        </div>
    
                      </div>
                    </ng-container>
                </div>             
                
                <div class="col-lg-6 col-md-6 col-xs-12" *ngIf="showSalesRepFields">
                  <div class="row g-0">
                    <div
                      class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                    >
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.pricelist
                        <span class="required">*</span>
                      </h4>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center" 
                    >
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-select
                            formControlName="pricelist"
                            placeholder="{{ 'pages.placeholders.Selectpricelist' | translate }}"
                          >
                            <mat-option
                              *ngFor="let pricelist of pricelists" 
                              [value]="pricelist"
                            >
                              {{ pricelist }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <div *ngIf="f.pricelist.touched && f.pricelist.invalid">
                          <div *ngIf="f.pricelist.errors.required">
                            <mat-hint class="text-danger ms-2">
                              {{'pages.placeholders.Pricelistisrequired' | translate }}</mat-hint
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                  <div class="col-lg-6 col-md-6 col-xs-12" *ngIf="showSalesRepFields">
                    <div class="row g-0">
                      <div
                        class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                      >
                        <h4 class="form-item-label" translate>
                          pages.newRetailer.creditLineAmount
                          <span class="required">*</span>
                        </h4>
                      </div>
                      <div
                        class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                      >
                        <div class="form-item-input">
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-hint matPrefix>$ &nbsp;</mat-hint>
                            <input
                              matInput
                              formControlName="creditLineAmnt"
                              placeholder="Enter Credit line amount"
                            />
                          </mat-form-field>
                          <div
                            *ngIf="
                              f.creditLineAmnt.touched && f.creditLineAmnt.invalid
                            "
                          >
                            <div *ngIf="f.creditLineAmnt.errors.required">
                              <mat-hint class="text-danger ms-2">
                                Credit line amount is required.</mat-hint
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-xs-12" *ngIf="showSalesRepFields">
                    <div class="row g-0">
                      <div
                        class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                      >
                        <h4 class="form-item-label" translate>
                          pages.newRetailer.setThreshold
                          <span *ngIf="autoReloadStatus" class="required">*</span>
                        </h4>
                      </div>
                      <div
                        class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                      >
                        <div class="form-item-input">
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-select
                              formControlName="thresholdAmnt"
                              placeholder="{{ 'pages.placeholders.Selectthresholdamount' | translate }}"
                            >
                              <mat-option>--</mat-option>
                              <mat-option
                                *ngFor="let amount of thresholdAmount"
                                [value]="amount"
                              >
                                {{ amount | currency }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                          <div
                            *ngIf="
                              f.thresholdAmnt.touched && f.thresholdAmnt.invalid
                            "
                          >
                            <div *ngIf="f.thresholdAmnt.errors.required">
                              <mat-hint class="text-danger ms-2">
                                {{ 'pages.placeholders.Thresholdamountisrequired' | translate }}</mat-hint
                              >
                            </div>
                          </div>
                          <div class="form-item-toggle">
                          <mat-slide-toggle
                            color="primary"
                            class="mb-2"
                            formControlName="autoReloadStatus"
                            (change)="checkautoReloadStatus($event)"
                          ></mat-slide-toggle> <span class=" d-inline ms-2">Set auto-relaod</span>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                
                <!--<div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div
                      class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                    >
                      <h4 class="form-item-label" translate>
                        IVR Access
                        <span class="required">*</span>
                      </h4>
                    </div>
  
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center" 
                    >
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-select (selectionChange)="onIvrStatusChange($event.value)"
                            formControlName="ivrAccess"
                            placeholder="Select IVRAccess"
                            selected="No"
                          >
                            <mat-option value='Yes'>Yes</mat-option>
                            <mat-option value='No'>No</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <div *ngIf="f.ivrAccess.touched && f.ivrAccess.invalid">
                          <div *ngIf="f.ivrAccess.errors.required">
                            <mat-hint class="text-danger ms-2">
                              IVR Access is required.</mat-hint
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-container  *ngIf="showIvrCode">
                    <div class="row g-0">
                      <div
                        class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                      >
                        <h4 class="form-item-label" translate>
                          IVR Code <span class="required">*</span>
                        </h4>
                      </div>
                      <div
                        class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                      >
                        <div class="form-item-input">
                          <mat-form-field appearance="outline" class="w-100" >
                            <input
                              matInput
                              required
                              formControlName="ivrCode"
                              minlength="4"
                              maxlength="4"
                              placeholder="4 Digit Code"
                              
                            />
                          </mat-form-field>
                          <div *ngIf="f.ivrCode.touched && f.ivrCode.invalid">
                            <div *ngIf="f.ivrCode.errors.required">
                              <mat-hint class="text-danger ms-2">
                                4 Digit Code is required.</mat-hint
                              >
                            </div>
                            <div *ngIf="f.ivrCode.errors.pattern">
                              <mat-hint class="text-danger ms-2">
                               Enter 4 Digit Code.</mat-hint
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div> -->
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div
                      class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                    >
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.address
                        <span class="required">*</span>
                      </h4>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                    >
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <input
                            matInput
                            required
                            formControlName="address1"
                            placeholder="{{'pages.AddProviders.Enteraddress' | translate }}"
                          />
                        </mat-form-field>
                        <div *ngIf="f.address1.touched && f.address1.invalid">
                          <div *ngIf="f.address1.errors.required">
                            <mat-hint class="text-danger ms-2">
                              {{ 'pages.placeholders.Addressisrequired' | translate }}</mat-hint
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div
                      class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                    >
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.city <span class="required">*</span>
                      </h4>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                    >
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <input
                            matInput
                            required
                            formControlName="city"
                            placeholder="{{'pages.AddProviders.Entercity' | translate }}"
                          />
                        </mat-form-field>
                        <div *ngIf="f.city.touched && f.city.invalid">
                          <div *ngIf="f.city.errors.required">
                            <mat-hint class="text-danger ms-2">
                              {{ 'pages.placeholders.Cityisrequired' | translate }}</mat-hint
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div
                      class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                    >
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.state <span class="required">*</span>
                      </h4>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                    >
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-select
                            formControlName="state"
                            placeholder="{{'pages.AddProviders.Selectstate' | translate }}"
                          >
                            <mat-option
                              *ngFor="let state of usStateZips"
                              [value]="state"
                            >
                              {{ state }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <div *ngIf="f.state.touched && f.state.invalid">
                          <div *ngIf="f.state.errors.required">
                            <mat-hint class="text-danger ms-2">
                              {{ 'pages.placeholders.Stateisrequired' | translate }}</mat-hint
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div
                      class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                    >
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.zipCode
                        <span class="required">*</span>
                      </h4>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                    >
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <input
                            matInput
                            required
                            #postalCode
                            type="text"
                            maxlength="5"
                            minlength="5"
                            formControlName="zip"
                            placeholder="{{
                              'pages.newRetailer.enterZipCode' | translate
                            }}"
                            #zipCode
                          />
                          <!--<mat-hint align="end"
                            >{{ zipCode.value.length }} / 5</mat-hint
                          > -->
                        </mat-form-field>
                        <div *ngIf="f.zip.touched && f.zip.invalid">
                          <div *ngIf="f.zip.errors.required">
                            <mat-hint class="text-danger ms-2">
                              {{ 'pages.placeholders.ZIPisrequired' | translate }}</mat-hint
                            >
                          </div>
                          <div *ngIf="f.zip.errors.pattern">
                            <mat-hint class="text-danger ms-2"
                              >{{ 'pages.placeholders.InvalidZIPformat' | translate }}
                            </mat-hint>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-footer mt-0 mb-4">
              <ul class="list-inline text-center">
                <li class="list-inline-item">
                  <button
                    mat-raised-button
                    [disabled]="!newUserForm.valid"
                    color="primary"
                    type="submit"
                  >
                    <span translate class="translate">pages.newRetailer.add</span>
                  </button>
                </li>
                <li class="list-inline-item">
                  <button
                    mat-stroked-button
                    color="primary" 
                    type="button"
                    (click)="onCancel()"
                  >
                    <span translate class="translate">pages.newRetailer.cancel</span>
                  </button>
                </li>
              </ul>
            </div>
           
          </form>
        </mat-card>
      </div>
    </div>
  </div>
</section>


